export default {
  Finished: 'Finished',
  Scheduled: 'Scheduled',
  ToPay: 'ToPay',
  OverduePayment: 'OverduePayment',
  Paid: 'Paid',
}
